import React from "react";
import { classNames } from "./classNames";

export const AdBanner = React.forwardRef<
  HTMLImageElement,
  React.ImgHTMLAttributes<HTMLImageElement>
>(({ className, style, ...rest }, ref) => (
  <img
    ref={ref}
    className={classNames(
      "absolute top-[24%] overflow-hidden h-auto z-[999] align-top border-0",
      className,
    )}
    alt="ad-banner"
    style={{
      width: "100%",
      maxWidth: "none",
      transform: "scaleY(1.6) scaleX(1.2)",
      transformOrigin: "top",
      ...style,
    }}
    {...rest}
  />
));

AdBanner.displayName = "AdBanner";
